import React, { Component } from 'react';
import { ReactComponent as Logo } from '../img/logo.svg'
import '../styles/nav.scss';

class Nav extends Component {
  render() {
    return (
      <nav id="main-nav">

        <a className="logo" href="#topper">
          <div className="nav-wrapper">

            {/*  <div className="nav-logo"></div> */}
              <div id="ar-logo">
                <Logo />
              </div>
              <div className="nav-name">ANDREA ROBERSON</div>

          </div>
        </a>

        <div className="link-set">
          <div className="element">
            <a className="base-link link" href="#work">work</a>
          </div>

          <div className="element">
            <a className="base-link link" href="#about">about</a>
          </div>

          <div className="element">
            <a className="base-link link" href="#contact">get in touch</a>
          </div>
        </div>

      </nav>
    );
  }
}

export default Nav;
